<template>
  <section class="news-screen-container main-container">
    <medium-title
        v-animateonscroll="{ enterClass: 'fade-in'}"
        :font-family="$isMobile
              ? 'EurostileR'
              : 'Eurostile'">
      {{ mainTitle }}
    </medium-title>
    <slider-banner v-animateonscroll="{ enterClass: 'fade-in'}"
                   :class-name="'news-card-container'"
                   :cards-info="cardsInfo">
      <template v-slot:card="{ item }">
        <card-banner class="news-card-container" :item="item"/>
      </template>
    </slider-banner>
  </section>
</template>

<script>
import SliderBanner from "@/components/entities/SliderBanner.vue";
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import CardBanner from "@/components/entities/cards/CardBanner.vue";
import banners from "@/static/values/banners";

export default {
  name: "NewsScreen",
  components: {CardBanner, MediumTitle, SliderBanner},
  mixins: [banners],
  data() {
    return {
      mainTitle: 'Новости'
    }
  }
}
</script>

<style scoped lang="scss">
  .news-screen-container {
    height: 350px;
    background: var(--color-avea-black);
    flex-direction: column;
    row-gap: 30px;
    padding-bottom: 40px;
    padding-top: 60px;
  }
</style>